export function Wordmark({ dark = false, size = "h-8" }) {
  if (!dark) {
    return (
      <img
        src="/temha-logo.png"
        alt="TEMHA"
        className={`${size} w-auto select-none`}
        data-testid="temha-wordmark"
      />
    );
  }
  return (
    <div className="flex items-center gap-2.5" data-testid="temha-wordmark">
      <img src="/temha-logo-white.png" alt="TEMHA" className={`${size} w-auto select-none`} />
    </div>
  );
}
